import { CountriesState } from './types'

export const DEFAULT_LANG = 'default'

export const initialState: CountriesState = {
  countries: [],
  ready: false,
}
